
import { Box } from '@mui/system';
import '../App.css';
import { useState, useContext } from 'react';
import styled from '@emotion/styled'
import { Grid } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useChangePasswordMutation, useResetPasswordMutation } from '../features/auth/authApiSlice';
import { GlobalStateContext } from '../store/GlobalState';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../features/auth/authSlice';
import { useTranslation } from "react-i18next";
import MainContent from '../components/MainContent';

const loginPageInputStyle = {
    height: '60px',
    width: '400px',
    borderRadius: 0,
    fontSize: 'calc(14px + 0.4vw)',
    paddingLeft: '12px',
    fontWeight: 300

}

const loginPageContainerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: 'calc(16px + 0.4vw)',
    width: '573px',
    margin: '0 auto',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const LoginPageHeadingContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: '573px',
    margin: '0 auto',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const LoginPageLabelContainer = styled.label`
    width: 173px;
    @media (max-width: 1080px) {
      /* Styles for small screens */
      width: 160px;
    }
    flex-wrap: wrap;
`;

const LoginPageLoginButton = styled.button`
    width: 400px;
    background: #21125B;
    color: white;
    font-size: calc(12px + 0.4vw);
    border-radius: 20px;
    height: 62px;
    font-weight: 600;
    cursor: pointer;
`


const LoginPageHeading2 = styled.p`
    font-weight: 600;
    border-bottom: 5px solid #21125B;
    padding-bottom: 10px;
    font-size: calc(32px + 0.4vw);
    margin-bottom: 50px;
    margin-top: 32px;
`

const WrongPassword = styled.span`
    font-size: 16px;
    color: red;
`

const ResetPasswordPage = () => {
    const { t } = useTranslation();
    const globalState = useContext(GlobalStateContext)
    const [resetPassword] = useResetPasswordMutation()
    const [newPassword, setNewPassword] = useState("")
    const [newPasswordRepeat, setNewPasswordRepeat] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleKeyDown = (setter: (x: any) => void) =>
        async (e: any) => {
            if (e.key === 'Enter') {
                await handleChangePassword(e)
            }
        }

    const handleChangePassword = async (e: any) => {
        e.preventDefault()
        if (newPassword === "")
            alert("New password cannot be empty.")
        else if (newPasswordRepeat === "")
            alert("Please input the new password again in the repeat field.")
        else if (newPasswordRepeat !== newPassword)
            alert("Two password input are different")
        else if (newPasswordRepeat.length < 8)
            alert("Password must be at least 8-character long.")
        else {
            try {
                await resetPassword({ email: searchParams.get("email"), token: searchParams.get("token"), password: newPassword }).unwrap().then(
                    () => {
                        alert("Password has been reset.")
                        navigate("/")
                    }
                )
            } catch (err: any) {
                if (err.status === 410) {
                    alert(err.data)
                    navigate("/")
                }
                else {
                    alert("Unknown error occured! Please contact System Support.")
                    navigate("/")
                }
            }
        }

    }

    return (
        <Grid container spacing={0}>
            {/* <Grid item xs={12} md={6}>
                    {/* Photo
                    <LoginPageImage src={loginPageImage} alt="login page photo" />
                </Grid> */}
            <Grid item xs={12} md={12}>
                <Box sx={LoginPageHeadingContainerStyle} >
                    <LoginPageHeading2>{t("Reset Password")}</LoginPageHeading2>
                </Box>

                {/* Input Boxes */}

                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer>{("New Password:")}</LoginPageLabelContainer>
                    <input name="newPassword" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} style={loginPageInputStyle}
                        onKeyDown={handleKeyDown(setNewPassword)} />
                </Box>
                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer>{("Repeat:")}</LoginPageLabelContainer>
                    <input name="newPasswordRepeat" type="password" value={newPasswordRepeat} onChange={(e) => setNewPasswordRepeat(e.target.value)} style={loginPageInputStyle}
                        onKeyDown={handleKeyDown(setNewPasswordRepeat)} />
                </Box>

                <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                    <LoginPageLabelContainer></LoginPageLabelContainer>
                    <WrongPassword>{errorMessage}</WrongPassword>
                </Box>

                {/* Buttons */}
                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer></LoginPageLabelContainer>
                    <LoginPageLoginButton onClick={handleChangePassword}>{t("Change Password")}</LoginPageLoginButton>
                </Box>
                {/* <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleBackButton}>{t("Back")}</LoginPageLoginButton>
                    </Box> */}
            </Grid>
        </Grid>
    );
};

export default ResetPasswordPage;
